<template>
	<div>
		<div class="card-group">
			<div class="card col-md-8 border-0">
				<div class="card-body border-0">
					<slot></slot>
				</div>
			</div>
			<div class="card col-md-4 border-0">
				<div class="card-header border-top-0">
					<h3 class="card-title">Datos de Auditoría</h3>
				</div>
				<div class="card-body">
					<auditoria :data="data"></auditoria>	
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		props: ['data'],

        computed: {
            info: function () {
                return JSON.parse(this.data);
            },
        }	
	}
</script>